import { ChangeCartPaymentModeResult } from '../../../graphql/cart/changeCartPaymentMode';
import { CustomOrderType } from '../../carts/CustomOrderType';
import { createAction } from '@reduxjs/toolkit';

export interface ApiCartChangeCartPaymentModeRequestedPayload {
  readonly actionId: number;
  readonly customOrderType: CustomOrderType;
  readonly parentActionId: number;
  readonly paymentMode: ApiCartPaymentMode;
}

export enum ApiCartPaymentMode {
  AMAZON_PAY = 'AMAZON_PAY',
  KLARNA = 'KLARNA',
  NONE = 'NONE',
  PAY_AT_STORE = 'PAY_AT_STORE',
  PAYPAL = 'PAYPAL'
}

export const apiCartChangeCartPaymentModeRequestedType =
  'api/cart/changeCartPaymentMode--requested';
export const apiCartChangeCartPaymentModeRequested =
  createAction<ApiCartChangeCartPaymentModeRequestedPayload>(
    apiCartChangeCartPaymentModeRequestedType
  );
export type ApiCartChangeCartPaymentModeRequestedAction = ReturnType<
  typeof apiCartChangeCartPaymentModeRequested
>;

export interface ApiCartChangeCartPaymentModeSucceededPayload {
  readonly cartId: string;
  readonly result: ChangeCartPaymentModeResult;
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartPaymentModeSucceededType =
  'api/cart/changeCartPaymentMode--succeeded';
export const apiCartChangeCartPaymentModeSucceeded =
  createAction<ApiCartChangeCartPaymentModeSucceededPayload>(
    apiCartChangeCartPaymentModeSucceededType
  );
export type ApiCartChangeCartPaymentModeSucceededAction = ReturnType<
  typeof apiCartChangeCartPaymentModeSucceeded
>;

export interface ApiCartChangeCartPaymentModeFailedPayload {
  readonly requestedActionId: number;
  readonly parentActionId: number;
}

export const apiCartChangeCartPaymentModeFailedType = 'api/cart/changeCartPaymentMode--failed';
export const apiCartChangeCartPaymentModeFailed =
  createAction<ApiCartChangeCartPaymentModeFailedPayload>(apiCartChangeCartPaymentModeFailedType);
export type ApiCartChangeCartPaymentModeFailedAction = ReturnType<
  typeof apiCartChangeCartPaymentModeFailed
>;
